const CSV_FILE =
  "https://res.cloudinary.com/ddzepzcq5/raw/upload/v1749803527/new_template_vzseio.csv";
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// get dynamic labels
const labelScript = document.getElementById("dynamic-labels");
console.log(labelScript.textContent);
const labels = labelScript ? JSON.parse(labelScript.textContent) : {};

// Demo data for now

let contactsData = [];
const getContractsData = async (customerId) => {
  console.log("customer id check ---  ", { customerId });
  if (customerId) {
    const url = `${window.BE_URL}/recipients/all/${customerId}`;
    const response = await fetch(url, {
      headers: {
        "ngrok-skip-browser-warning": "true",
      },
    });
    const recipients = await response.json();
    console.log({ recipients }, "data length --", recipients.data.length);
    if (recipients.data.length > 0) {
      contactsData = recipients.data.map((recipient) => {
        return { name: recipient.name, email: recipient.email };
      });
    }
  }
};

// const contactsData = [
//   { name: "John Doe", email: "john.doe@example.com", message: "Test" },
//   {
//     name: "Jane Smith",
//     email: "jane.smith@example.com",
//     message: "+0987654321",
//   },
//   {
//     name: "Bob Johnson",
//     email: "bob.johnson@example.com",
//     message: "+1122334455",
//   },
//   {
//     name: "Alice Williams",
//     email: "alice.williams@example.com",
//     message: "+5566778899",
//   },
//   {
//     name: "Charlie Brown",
//     email: "charlie.brown@example.com",
//     message: "+2233445566",
//   },
// ];

const recipeintFormHandler = (uniqueCheckbox) => {
  const messageInputs = document.querySelectorAll(".recipient-message");
  const messageBlocks = document.querySelectorAll(".recipient-section");
  const recipientFormInput = document.querySelectorAll(".recipient-form-input");
  const commonCustomFormInput = document.querySelector(".custom-form-input");

  messageInputs.forEach((input) => {
    if (uniqueCheckbox.checked) {
      input.classList.remove("hide");
    } else {
      input.classList.add("hide");
    }
  });

  if (uniqueCheckbox.checked) {
    commonCustomFormInput.classList.add("hide");
  } else {
    commonCustomFormInput.classList.remove("hide");
  }

  messageBlocks.forEach((block) => {
    if (uniqueCheckbox.checked) {
      block.classList.remove("compact");
    } else {
      block.classList.add("compact");
    }
  });

  recipientFormInput.forEach((formInput) => {
    if (uniqueCheckbox.checked) {
      formInput.style.width("50%");
    } else {
      formInput.style.width("100%");
    }
  });
};

function autoScrollPage() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

function renderRecipientSections(recipeintData, fromBulk = false) {
  let count = parseInt(document.getElementById("recipients-options").value);
  let recipeintValues = recipeintData || [];

  // pre filling values
  const filledRecipientValues = []; 
  const recipientNames = Array.from(document.querySelectorAll(".searchable-name-input"))?.map((nameInput) => nameInput?.value || "") || [];
  const recipientEmails =Array.from(document.querySelectorAll(".recipient-form-email"))?.map((emailInput) => emailInput?.value || "") || [];
  const recipientMessages = Array.from(document.querySelectorAll(".recipient-form-message"))?.map((messageInput) => messageInput?.value || '') || []
  const maxCount = Math.max(recipientNames?.length||0, Math.max(recipientEmails?.length||0, recipientMessages?.length||0)); 
  for(let i=0;i<maxCount;++i){
    filledRecipientValues.push({name: recipientNames[i]||"", email: recipientEmails[i]||"", message: recipientMessages[i]||""})
  }


  let wrapper = document.getElementById("recipient-sections-wrapper");
  wrapper.innerHTML = "";


  if (recipeintValues?.length) {
    wrapper = document.getElementById("recipient-sections-wrapper-bulk");
    wrapper.innerHTML = "";
    count = recipeintValues.length;
  }  else {
    recipeintValues = filledRecipientValues; 
  }
    
  const uniqueSelctor = document.querySelector("#unique-checkbox");
  for (let i = 0; i < count; i++) {
    const recipientBlock = `
      <div class="recipient-section data-recipient='${i}'">
        <div class="recipient-header">
            <div class="form-recipient-input-heading">Recipient ${i + 1}</div>
            <span class="delete-recipient ${
              count <= 1 && "hide"
            }" title="Remove Recipient">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5" stroke="#EB4747" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </span>
        </div>
        <div class="form-inputs-group recipient-form-group">
          <div class="recipient-form-input">
            <label for="recipient-name-${i}">${labels.recipientNameLabel || "Recipient's name"}</label>
            <div name="recipient-name-${i}" class="searchable-dropdown-container " style="position: relative;">
              <input 
                type="text" 
                required
                class="recipient-form-input form-control sender-form-input searchable-name-input" 
                id="recipient-name-${i}" 
                autocomplete="off"
                oninput="handleNameSearch(${i})"
                onfocus="showDropdown(${i})"
                onblur="hideDropdown(${i})"
                value="${recipeintValues[i]?.name || ""}"
              />
              <div class="dropdown-list" id="dropdown-${i}" style="
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                background: white;
                border: 1px solid #A6A6A6;
                border-top: none;
                border-radius: 0 0 10px 10px;
                max-height: 200px;
                overflow-y: auto;
                z-index: 1000;
                display: none;
              "></div>
            </div>
          </div>
          <div class="recipient-form-input">
            <label for="recipient-email-${i}">${labels.recipientEmailLabel || "Email Address"}</label>
            <input type="email" name="recipient-email-${i}" class="recipient-form-email recipient-form-input form-control sender-form-input" id="recipient-email-${i}" value="${
      recipeintValues[i]?.email || ""
    }" required/>
          </div>
          <div class="recipient-form-input last-input recipient-message">
            <label for="recipient-message-${i}">${labels.recipientMessageLabel || "Message"}</label>
            <input type="text" name="recipient-message-${i}" id="recipient-message-${i}" class=" recipient-form-input recipient-form-message form-control sender-form-input "  value="${
      recipeintValues[i]?.message || ""
    }"></input>
          </div>
        </div>
      </div>
    `;
    wrapper.insertAdjacentHTML("beforeend", recipientBlock);
  }

  // Add event listeners to delete buttons
  wrapper.addEventListener("click", function (e) {
    if (e.target.closest(".delete-recipient")) {
      const recipientSection = e.target.closest(".recipient-section");
      if (recipientSection) {
        recipientSection.remove();
        document
          .querySelectorAll(".form-recipient-input-heading")
          .forEach((formInput, index) => {
            formInput.innerHTML = `Recipient ${index + 1}`;
          });
      }
    }
  });

  recipeintFormHandler(uniqueSelctor);
}

function goToNextSection(currentId, nextId) {
  const currentSection = document.getElementById(currentId);
  const nextSection = document.getElementById(nextId);

  if (currentSection && nextSection) {
    currentSection.style.display = "none";
    nextSection.style.display = "block";
    nextSection.scrollIntoView({ behavior: "smooth" });

    // Extract step number from section ID like "sub-nav-section-2" → 2
    const step = parseInt(nextId.split("-").pop());

    // Remove active class from all sub-nav tabs
    document.querySelectorAll(".sub-nav-header").forEach((header) => {
      header.classList.remove("sub-nav-active");
    });

    // Add active class to the corresponding sub-nav tab
    const activeTab = document.querySelector(
      `.sub-nav-header[data-sub-nav-step="${step}"]`
    );
    if (activeTab) {
      activeTab.classList.add("sub-nav-active");
    }
  }
}

function getNotificationDate() {
  const dateInput = document.getElementById("recipient-date");
  return dateInput?.value || "";
}
function getCustomMessage() {
  const customMessageInput = document.getElementById("custom-message");
  return customMessageInput?.value.trim() || "";
}

function getRecipientDetails() {
  const recipients = [];
  const rows = document.querySelectorAll(".recipient-section");
  rows.forEach((row) => {
    const name = row.querySelector('input[id^="recipient-name"]')?.value || "";
    const email =
      row.querySelector('input[id^="recipient-email"]')?.value || "";
    const message =
      row.querySelector('input[id^="recipient-message"]')?.value || "";
    recipients.push({ name, email, message });
  });
  return recipients;
}

function getSelectedVariantId() {
  const activeBtn = document.querySelector(".price-filter-btn.active");
  return activeBtn?.dataset.variantId;
}

function getSenderDetails() {
  const form = document.querySelector(".recipient-form");
  return {
    name: form.querySelector("#sender-name")?.value.trim() || "",
    email: form.querySelector("#sender-email")?.value.trim() || "",
    company: form.querySelector("#company-name")?.value.trim() || "",
  };
}

function getIncludeInCCData() {
  return document.getElementById("copy-email-checkbox").checked; 
}

function getRecipientsNumber() {
  return document.querySelector(".recipients-number").value;
}

// for managing step
function showStep(stepNumber, steps) {
  const giftChooseSection = document.querySelector(".choose-gift-section");
  steps.forEach((step) => {
    step.classList.remove("active");
    if (Number(step.dataset.step) === stepNumber) {
      step.classList.add("active");
    }
  });

  setActiveStep(stepNumber);

  if (stepNumber === 1) {
    giftChooseSection.classList.add("show-gifts");
    giftChooseSection.classList.remove("hide-gifts");
  } else {
    giftChooseSection.classList.remove("show-gifts");
    giftChooseSection.classList.add("hide-gifts");
  }
}

// for handling top navigation
function setActiveStep(stepNumber) {
  document.querySelectorAll(".nav-item").forEach((item) => {
    const index = Number(item.getAttribute("data-step-index"));
    if (index === stepNumber) {
      item.classList.add("active");
    } else {
      item.classList.remove("active");
    }
  });
}

function showError(input, message) {
  console.log("inside show error ", {input})
  input.classList.add("input-error");

  let errorEl = input.nextElementSibling;
  console.log({errorEl})
  if (!errorEl || !errorEl.classList.contains("error-text")) {
    errorEl = document.createElement("span");
    errorEl.className = "error-text";
    input.parentNode.insertBefore(errorEl, input.nextSibling);
  }

  errorEl.textContent = message;
}

function clearError(input) {
  input.classList.remove("input-error");

  const errorEl = input.nextElementSibling;
  if (errorEl && errorEl.classList.contains("error-text")) {
    errorEl.remove();
  }
}

function handleGifsCategories () {
  const images = document.querySelectorAll(".select-photo-image");
  const buttons = document.querySelectorAll(".filter-btn");

    buttons.forEach(button => {
      button.addEventListener("click", () => {
        // Set active button styling
        buttons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");

        const selectedCategory = button.getAttribute("data-category");

        images.forEach(img => {
          const imgCategory = img.getAttribute("data-category");

          if (selectedCategory === "all" || imgCategory === selectedCategory) {
            img.style.display = "inline-block";
          } else {
            img.style.display = "none";
          }
        });
      });
    });
} 

function showImageError (className) {
  const photoErrorElement = document.querySelector(`.${className}`);
  photoErrorElement.classList.remove("hide");
  setTimeout(() => {
    photoErrorElement.classList.add("hide");
  },3000);
}

function populatSendDate () {
    console.log("inside populate date")
    const today = new Date(); 
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months start at 0
    const dd = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${yyyy}-${mm}-${dd}`;
    console.log("formatted date", formattedDate)
    document.getElementById("recipient-date").value = formattedDate;

}

document.addEventListener("DOMContentLoaded", () => {
  const customerId = window.customerId;

  const selectAll = document.getElementById("select-all-main");
  const giftCheckboxes = document.querySelectorAll(".gift-checkbox");
  const stepContinueBtns = document.querySelectorAll("[data-continue-step]");
  const steps = document.querySelectorAll(".step");
  const uniqueCheckbox = document.querySelector("#unique-checkbox");
  let currentStep = 1;
  const totalSteps = steps.length;
  const addToCartBtn = document.getElementById("add-to-cart");

  const headers = document.querySelectorAll(".sub-nav-header");
  const sections = document.querySelectorAll(".sub-nav-section");

  const bulkUploadButton = document.querySelector("#bulk-upload-button");
  const csvFileInput = document.getElementById("csvFileInput");
  const bulkDownloadBtn = document.getElementById("bulk-download-button");
  const navButtons = document.querySelectorAll(".nav-item");

  // reciepents form
  const formTopSettings = document.querySelector(".form-settings");
  const reicipeintCounter = document.querySelector(".recipients-select");
  const bulkdUploadSection = document.querySelector(".bulk-upload-section");
  const reciepentsCount = document.querySelector(".recipients-form-number");
  const customMessageInputSection =
    document.querySelector(".custom-form-input");

  const isUploading = {
    isLogoUploading: false,
    isPhotoUploading: false,
  };

  // variables required for email section
  const logoBox = document.getElementById("upload-logo-box");
  const logoInput = document.getElementById("logo-file-input");
  const previewLogo = document.getElementById("preview-logo");
  const uploadedLogo = document.getElementById("uploaded-logo");
  const uploadedLogoWrapper = document.getElementById("uploaded-logo-wrapper");
  const deleteLogoBtn = document.getElementById("delete-logo-btn");

  const photoBox = document.getElementById("upload-photo-box");
  const photoInput = document.getElementById("photo-file-input");
  const previewImage = document.getElementById("preview-image");
  const uploadedPhoto = document.getElementById("uploaded-photo");
  const uploadedPhotoWrapper = document.getElementById(
    "uploaded-photo-wrapper"
  );
  const deletePhotoBtn = document.getElementById("delete-photo-btn");

  const selectPhotoDiv = document.getElementById("select-photo");

  // selected variables
  let selectedGifts = [];
  const imageUrls = {
    logoUrl: previewLogo.src,
    imageUrl: "",
    gifSelected: false,
  };

  getContractsData(customerId);

  document.querySelectorAll(".sub-nav-section").forEach((el, index) => {
    el.style.display = index === 0 ? "block" : "none";
  });

  // Toggle all gift checkboxes when "Select All" is clicked
  function toggleAllGiftCheckboxes(source) {
    const checkboxes = document.querySelectorAll(".gift-checkbox");
    checkboxes.forEach((checkbox) => {
      checkbox.checked = source.checked;
    });
  }

  // Attach event to "Select All" checkbox
  selectAll.addEventListener("change", (e) => {
    toggleAllGiftCheckboxes(e.target);
    const selectAllBg = document.querySelector(".select-all-checkbox-bg");
    if(!selectAll.checked) {
      selectAllBg.classList.add("select-all-empty");
    } else {
      selectAllBg.classList.remove("select-all-empty");
    }
  });

  // Attach event to each gift-checkbox
  giftCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      console.log("clicked here -- checkbox ")
      checkbox.checked = !checkbox.checked; 
      const allChecked = [...giftCheckboxes].every((cb) => cb.checked);
      selectAll.checked = allChecked;
      const selectAllBg = document.querySelector(".select-all-checkbox-bg");
      if(!allChecked) {
        selectAllBg.classList.add("select-all-empty");
      } else {
        selectAllBg.classList.remove("select-all-empty");
      }
    });
  });

  

  // Attach Event Listeners to top nav section
  navButtons.forEach((navBtn) => {
    navBtn.addEventListener("click", () => {
      const stepNumber = parseInt(navBtn.getAttribute("data-step-index"), 10);
      if (stepNumber < currentStep) {
        currentStep = stepNumber;
        showStep(stepNumber, steps);
      }
    });
  });

  // Download CSV file
  bulkDownloadBtn?.addEventListener("click", () => {
    const link = document.createElement("a");
    link.href = CSV_FILE;
    link.download = "template.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });

  function nextStep() {
    if (currentStep < totalSteps) {
      currentStep++;
      showStep(currentStep, steps);
    }
  }

  function prevStep() {
    if (currentStep > 1) {
      currentStep--;
      showStep(currentStep, steps);
    }
  }

  function updateButtonState(isAddingToCart = false) {
    const button = document.getElementById("add-to-cart");
    const uploading = isAddingToCart
      ? true
      : isUploading.isLogoUploading || isUploading.isPhotoUploading;
    console.log("uploading ", {uploading})
    button.disabled = uploading;
    if(uploading) button.classList.add("disable-button");
    else button.classList.remove("disable-button");
    button.textContent = isAddingToCart
      ? "Adding to Cart..."
      : uploading
      ? "Uploading..."
      : "Next";
  }

  // listening to step next
  stepContinueBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      giftCheckboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          const checkboxId = checkbox.id;
          selectedGifts.push(checkboxId.split("gift-")[1]);
        }
      });

      const giftError = document.querySelector(".gift-error");
      if (selectedGifts.length <= 0) {
        giftError.classList.remove("hide");
        return;
      } else {
        giftError.classList.add("hide");
      }

      const isStep2Active = document
        .querySelector('[data-step="2"]')
        .classList.contains("active");

      const activeSection = Array.from(
        document.querySelectorAll(".sub-nav-section")
      ).find(
        (section) =>
          section.style.display !== "none" &&
          !section.classList.contains("hide")
      );

      const set3SectionId = "sub-nav-section-3";

      if (isStep2Active) {
        let allFilled = true;
        const form = document.querySelector(".recipient-form");
        const inputs = form.querySelectorAll("input, select, textarea");
        inputs.forEach((input) => {
          if (input.hasAttribute("required") && input.value.trim() === "") {
            if (
              input.classList.contains("recipient-form-input") &&
              activeSection.id == set3SectionId
            ) {
              clearError(input);
            } else {
              showError(input, "This field is required");
              allFilled = false;
            }
          } else {
            clearError(input);
          }
          if (input.id === "terms-checkbox")
            console.log("check input value --- ", input.checked, { input });
          if (input.id === "terms-checkbox" && !input.checked) {
            allFilled = false;
            const termsErrorElement = document.querySelector(".terms-error");
            termsErrorElement.classList.remove("hidden");
            termsErrorElement.classList.add("error-text");
          } else {
            const termsErrorElement = document.querySelector(".terms-error");
            termsErrorElement.classList.remove("error-text");
            termsErrorElement.classList.add("hidden");
          }

          if (input.type === "email") {
            console.log("email id check", input.id);
            console.log(
              "in input condition check",
              input,
              input.classList.contains("recipient-form-email"),
              { activeSection, set3SectionId },
              activeSection == set3SectionId
            );
            if (
              input.classList.contains("recipient-form-email") &&
              activeSection.id == set3SectionId
            ) {
              clearError(input);
            } else if (!EMAIL_REGEX.test(input.value.trim())) {
              console.log("regex failed !!");
              console.log({input}, 'checkingiiiiikiiik')
              showError(input, "Please enter a valid email address");
              allFilled = false;
            } else {
              clearError(input);
            }

            if (input.id === "sender-email" && input.value) {
              let isError = false;
              const allRecipientEmailInputs = document.querySelectorAll(
                ".recipient-form-email"
              );
              const recipientEmailsValues = Array.from(
                allRecipientEmailInputs
              ).map((recipientEmailInput) => recipientEmailInput.value.trim());
              if (recipientEmailsValues.includes(input.value.trim())) {
                showError(
                  input,
                  "Sender email and recipient email can never be the same."
                );
                allFilled = false;
                isError = true;
              }

              if (!isError) {
                clearError(input);
              }
            }
            if (input.classList.contains("recipient-form-email") && allFilled) {
              let isError = false;
              const allRecipientEmailInputs = document.querySelectorAll(
                ".recipient-form-email"
              );
              Array.from(allRecipientEmailInputs).forEach(
                (recipientEmailInput) => {
                  if (
                    recipientEmailInput.value.trim() === input.value.trim() &&
                    input.id !== recipientEmailInput.id
                  ) {
                    allFilled = false;
                    isError = true;
                    console.log("adding error for the recipient unqiueness");
                    showError(input, "Two recipients cannot have same email");
                  }
                }
              );
              if (!isError) {
                clearError(input);
              }
            }
          }
        });

        if (activeSection.id == set3SectionId) {
          const recipientInput = document.querySelector(".recipients-number");
          if (!recipientInput?.value)
            showError(recipientInput, "Please enter a valid Number here");
          else clearError(recipientInput);
        }

        const isUniqueMessage =
          document.querySelector("#unique-checkbox").checked;
        if (activeSection.id != set3SectionId) {
          if (isUniqueMessage) {
            const msgInput = document.querySelectorAll(
              ".recipient-form-message"
            );
            msgInput.forEach((msg) => {
              if (msg.value?.trim() === "") {
                showError(msg, "Please enter a message for this recipient");
              } else {
                clearError(msg);
              }
            });
          } else {
            const customMessageInput =
              document.getElementById("custom-message");
            if (customMessageInput.value?.trim() === "") {
              showError(customMessageInput, "Please enter your Message");
            } else {
              clearError(customMessageInput);
            }
          }
        }
        if (!allFilled) return;
      }

      if (activeSection) {
        if (activeSection.id == set3SectionId) {
          addToCart(steps, selectedGifts, true, true);
          return;
        }
      }

      // updating email template data
      if (currentStep == 2) {
        const senderName = document.getElementById("sender-name").value;
        const recipientName = document.querySelector(
          ".searchable-name-input"
        ).value;
        const uniqueCustomMessage =
          document.getElementById("custom-message")?.value;
        const recipientCustomMessage = document.querySelector(
          ".recipient-form-message"
        )?.value;
        const companyName = document.getElementById("company-name")?.value;

        document.getElementById(
          "greeting-text"
        ).textContent = `Hey ${recipientName}, ${senderName} ${
          companyName && `with ${companyName}`
        } has sent you a gift 🥳`;
        document.getElementById("your-message").textContent =
          uniqueCustomMessage ? uniqueCustomMessage : recipientCustomMessage;
      }
      nextStep();
      autoScrollPage();
    });
  });

  headers.forEach((header) => {
    header.addEventListener("click", () => {
      // Remove active state from all headers
      headers.forEach((h) => h.classList.remove("sub-nav-active"));

      // Hide all sections
      sections.forEach((s) => (s.style.display = "none"));

      // Activate clicked header
      header.classList.add("sub-nav-active");

      // Show corresponding section
      const step = header.getAttribute("data-sub-nav-step");
      const sectionToShow = document.getElementById(`sub-nav-section-${step}`);
      const form = document.querySelector("recipient-form");
      if (sectionToShow) {
        sectionToShow.style.display = "block";
      }

      // if (form == 1 || form == 2 || form == 3) {
      //   form.classList.remove("hide");
      // }

      if (step == 3) {
        formTopSettings.classList.add("hide");
      } else {
        formTopSettings.classList.remove("hide");
      }
      if (step == 2) {
        bulkdUploadSection.classList.remove("hide");
        reicipeintCounter.classList.add("hide");
      } else {
        reicipeintCounter.classList.remove("hide");
        bulkdUploadSection.classList.add("hide");
      }
      if (step == 3) {
        reciepentsCount.classList.remove("hide");
        customMessageInputSection.classList.add("hide");
      } else {
        reciepentsCount.classList.add("hide");
        const isUniqueCached =
          document.querySelector("#unique-checkbox").checked;
        if (!isUniqueCached) customMessageInputSection.classList.remove("hide");
      }
    });
  });

  // uploading button for csv functionality
  bulkUploadButton.addEventListener("click", () => {
    csvFileInput.click(); // Open file picker
  });

  csvFileInput.addEventListener("change", () => {
    const file = csvFileInput.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    fetch(`${window.BE_URL}/uploads/recipients`, {
      method: "POST",
      body: formData,
      headers: {
        "ngrok-skip-browser-warning": "true",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        renderRecipientSections(data.data, true);
      })
      .catch((err) => {
        console.error("Upload failed:", err);
      });
  });

  uniqueCheckbox.addEventListener("change", () => {
    recipeintFormHandler(uniqueCheckbox);
  });

  // function getSelectedProductIds() {
  //   const selectedCheckboxes = document.querySelectorAll(
  //     ".gift-checkbox:checked"
  //   );
  //   return Array.from(selectedCheckboxes).map((cb) => cb.value);
  // }

  // TODO : Handle for quantity
  const addToCart = async (
    steps,
    selectedGifts,
    linkOnly,
    jumpToCartStep
    // logoUrl,
    // imageUrl
  ) => {
    const recipientDetails = getRecipientDetails();
    const variantId = getSelectedVariantId();
    const notifiedDate = getNotificationDate();
    const customMsg = getCustomMessage();
    const senderData = getSenderDetails();
    const includeCC = getIncludeInCCData();

    console.log("check sender data --- ", { senderData });
    const linkRecipientNumber = getRecipientsNumber();
    const imageUrl = document.getElementById("preview-image")?.src;
    const items = [
      {
        id: parseInt(variantId),
        quantity: linkOnly ? linkRecipientNumber : recipientDetails.length,
        properties: {
          __recipients: recipientDetails,
          __senderInfo: senderData,
          __linkOnly: linkOnly,
          __recipientsNumber: linkRecipientNumber,
          __selectableGifts: selectedGifts,
          __notifiedDate: notifiedDate || Date.now(),
          __customMsg: customMsg,
          __logoUrl: imageUrls.logoUrl,
          __photoUrl: imageUrl.includes(labels.previewPhotoUrl) ? "" : imageUrls.imageUrl || imageUrl,
          __nonEditable: true, // not editable in cart sent and used in cart to hide inc/dec in cart for this specific item.
          __includeCC: includeCC,  
        },
      },
    ];

    updateButtonState(true);
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((res) => res.json())
      .then(() => {
        // addd handling to jump to step 4
        if (jumpToCartStep) {
          showStep(4, steps);
          return;
        }
        nextStep();
        autoScrollPage();
        updateButtonState();
      })
      .catch((err) => {
        console.error("Add to cart error:", err);
        updateButtonState();
      });
  };

  addToCartBtn.addEventListener("click", () => {
    addToCart(steps, selectedGifts, false);
  });

  //logo upload
  if (logoBox && logoInput && previewLogo && uploadedLogo) {
    function handleFile(file) {
      const reader = new FileReader();
      reader.onload = function (e) {
        const src = e.target.result;
        previewLogo.src = src;
        uploadedLogo.src = src;

        logoBox.style.display = "none";
        uploadedLogoWrapper.style.display = "inline-block";

        const formData = new FormData();
        formData.append("file", file);
        isUploading.isLogoUploading = true;
        updateButtonState();

        fetch(`${window.BE_URL}/uploads/single`, {
          method: "POST",
          body: formData,
          headers: {
            "ngrok-skip-browser-warning": "true",
          },
        })
          .then((res) => res.json())
          .then((data) => {
            isUploading.isLogoUploading = false;
            updateButtonState();
            imageUrls.logoUrl = data.data.secureUrl;
          })
          .catch((err) => {
            console.log("Upload failed:", err);
            // const previewLogoElement = document.getElementById("preview-logo")
            logoInput.value = "";
            uploadedLogoWrapper.style.display = "none";
            logoBox.style.display = "flex";
            previewLogo.src = previewLogo.dataset.defaultSrc ; 
            isUploading.isLogoUploading = false;
            showImageError("logo-error");
            updateButtonState();
          });
      };
      reader.readAsDataURL(file);
    }

    logoBox.addEventListener("click", () => logoInput.click());

    logoInput.addEventListener("change", function () {
      const file = this.files[0];
      if (file) {
        handleFile(file);
      }
    });

    // DRAG & DROP SUPPORT
    logoBox.addEventListener("dragover", (e) => {
      e.preventDefault();
      logoBox.classList.add("dragover");
    });

    logoBox.addEventListener("dragleave", () => {
      logoBox.classList.remove("dragover");
    });

    logoBox.addEventListener("drop", (e) => {
      e.preventDefault();
      logoBox.classList.remove("dragover");

      const file = e.dataTransfer.files[0];
      if (file) {
        logoInput.files = e.dataTransfer.files; // Set file to input for consistency
        handleFile(file);
      }
    });

    deleteLogoBtn.addEventListener("click", () => {
      logoInput.value = "";
      uploadedLogoWrapper.style.display = "none";
      logoBox.style.display = "flex";

      previewLogo.src = previewLogo.dataset.defaultSrc;
    });
  }

  //photo upload
  if (photoBox && photoInput && previewImage && uploadedPhoto) {
    photoBox.addEventListener("click", () => photoInput.click());

    function handlePhotoUpload(file) {
      const reader = new FileReader();
      reader.onload = function (e) {
        const src = e.target.result;
        previewImage.src = src;
        imageUrls.gifSelected = true; 
        uploadedPhoto.src = src;
        photoBox.style.display = "none";
        uploadedPhotoWrapper.style.display = "inline-block";

        const formData = new FormData();
        formData.append("file", file);
        isUploading.isPhotoUploading = true;
        updateButtonState();
        fetch(`${window.BE_URL}/uploads/single`, {
          method: "POST",
          body: formData,
          headers: {
            "ngrok-skip-browser-warning": "true",
          },
        })
          .then((res) => res.json())
          .then((data) => {
            isUploading.isPhotoUploading = false;
            imageUrls.imageUrl = data.data.secureUrl;
            updateButtonState();
          })
          .catch((err) => {
            photoInput.value = "";
            uploadedPhotoWrapper.style.display = "none";
            photoBox.style.display = "flex";
            previewImage.src = previewImage.dataset.defaultSrc;
            isUploading.isPhotoUploading = false;
            updateButtonState();
            showImageError("image-error");            
            console.error("Upload failed:", err);
          });

        // Hide the select-photo section
        if (selectPhotoDiv) selectPhotoDiv.style.display = "none";
      };
      reader.readAsDataURL(file);
    }

    photoInput.addEventListener("change", function () {
      const file = this.files[0];
      if (file) {
        handlePhotoUpload(file);
      }
    });

    // DRAG & DROP SUPPORT
    photoBox.addEventListener("dragover", (e) => {
      e.preventDefault();
      photoBox.classList.add("dragover");
    });

    photoBox.addEventListener("dragleave", () => {
      photoBox.classList.remove("dragover");
    });

    photoBox.addEventListener("drop", (e) => {
      e.preventDefault();
      photoBox.classList.remove("dragover");

      const file = e.dataTransfer.files[0];
      if (file) {
        photoInput.files = e.dataTransfer.files; // Set file to input for consistency
        handlePhotoUpload(file);
      }
    });

    deletePhotoBtn.addEventListener("click", () => {
      photoInput.value = "";
      uploadedPhotoWrapper.style.display = "none";
      photoBox.style.display = "flex";

      previewImage.src = previewImage.dataset.defaultSrc;
      imageUrls.gifSelected = false; 
      imageUrls.imageUrl = "";
      

      // Show the select-photo section again
      if (selectPhotoDiv) selectPhotoDiv.style.display = "block";
    });
  }

  // === SELECTABLE PHOTO IMAGES ===
  const selectableImages = document.querySelectorAll(".select-photo-image");
  selectableImages.forEach((img) => {
    img.addEventListener("click", () => {
      const src = img.dataset.src;

      previewImage.src = src;
      imageUrls.gifSelected = true; 
      uploadedPhoto.src = src;

      uploadedPhotoWrapper.style.display = "inline-block";
      photoBox.style.display = "none";

      photoInput.value = "";

      if (selectPhotoDiv) selectPhotoDiv.style.display = "none";
    });
  });

  document.getElementById("open-terms").addEventListener("click", function () {
    document.getElementById("terms-modal").classList.remove("hidden");
  });

  document.getElementById("close-terms").addEventListener("click", function () {
    document.getElementById("terms-modal").classList.add("hidden");
  });


  // Add event listeners to delete buttons
  document.getElementById("recipient-sections-wrapper").addEventListener("click", function (e) {
    if (e.target.closest(".delete-recipient")) {
      const recipientSection = e.target.closest(".recipient-section");
      if (recipientSection) {
        recipientSection.remove();
        document
          .querySelectorAll(".form-recipient-input-heading")
          .forEach((formInput, index) => {
            formInput.innerHTML = `Recipient ${index + 1}`;
          });
        
      }

      const recipientSectionsLength = document.querySelectorAll(".recipient-section").length ;
      if(recipientSectionsLength <=1) {
        document.querySelector(".delete-recipient").classList.add("hide");
      }
      const recipientCount =  document.getElementById("recipients-options");
        console.log({count:recipientCount.value})
        recipientCount.value = recipientCount.value - 1; 
    }
  });


  // For GIFS categories click handle 
  handleGifsCategories();

  // prepopulate today's date
  populatSendDate()

  // Select all cards
  const giftCards = document.querySelectorAll('.gift-item');
  giftCards.forEach((card) => {
    card.addEventListener('click', (event) => {
      // Skip if user directly clicked the checkbox
      if (event.target.tagName.toLowerCase() === 'input') return;

      const checkbox = card.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
      }

      const allChecked = [...giftCheckboxes].every((cb) => cb.checked);
      selectAll.checked = allChecked;
      const selectAllBg = document.querySelector(".select-all-checkbox-bg");
      if(!allChecked) {
        selectAllBg.classList.add("select-all-empty");
      } else {
        selectAllBg.classList.remove("select-all-empty");
      }
    });
  });

  const recipientInput = document.querySelector(".recipients-number");
  recipientInput.addEventListener("input", function () {
    if (this.value < 1) {
      this.value = 1;
    }
  });


  window.addEventListener("click", function (event) {
    const modal = document.getElementById("terms-modal");
    if (event.target === modal) {
      modal.classList.add("hidden");
    }
  });
});

window.addEventListener("DOMContentLoaded", renderRecipientSections);

const nextToProductSelectionBtn = document.getElementById("goto-step-3");

nextToProductSelectionBtn.addEventListener("click", (e) => {
  e.preventDefault();

  document
    .querySelectorAll(".step")
    .forEach((el) => el.classList.remove("active"));

  const step3 = document.querySelector('[data-step="3"]');
  if (step3) {
    step3.classList.add("active");
    step3.scrollIntoView({ behavior: "smooth" });
  }
});

function handleNameSearch(index) {
  const input = document.getElementById(`recipient-name-${index}`);
  const dropdown = document.getElementById(`dropdown-${index}`);
  const searchTerm = input.value.toLowerCase();

  if (searchTerm.length === 0) {
    populateDropdown(index, contactsData);
  } else {
    const filteredContacts = contactsData.filter((contact) =>
      contact.name.toLowerCase().includes(searchTerm)
    );
    populateDropdown(index, filteredContacts);
  }

  dropdown.style.display = "block";
}

// Populate dropdown with contacts
function populateDropdown(index, contacts) {
  const dropdown = document.getElementById(`dropdown-${index}`);

  if (contacts.length === 0) {
    dropdown.innerHTML =
      '<div style="padding: 10px; color: #666;">No contacts found</div>';
    return;
  }

  dropdown.innerHTML = contacts
    .map(
      (contact) => `
    <div class="dropdown-item" style="
      padding: 10px;
      cursor: pointer;
      border-bottom: 1px solid #f0f0f0;
      transition: background-color 0.2s;
    " 
    onmouseover="this.style.backgroundColor='#f8f9fa'" 
    onmouseout="this.style.backgroundColor='white'"
    onmousedown="selectContact(${index}, '${contact.name}', '${contact.email}', '${contact.email}')">
      <div style="font-weight: 500;">${contact.name}</div>
      <div style="font-size: 0.85em; color: #666;">${contact.email}</div>
    </div>
  `
    )
    .join("");
}

// Select contact and autofill
function selectContact(index, name, email, message) {
  document.getElementById(`recipient-name-${index}`).value = name;
  document.getElementById(`recipient-email-${index}`).value = email;
  // document.getElementById(`recipient-message-${index}`).value = message;

  // Hide dropdown
  setTimeout(() => {
    document.getElementById(`dropdown-${index}`).style.display = "none";
  }, 100);
}

// Show dropdown
function showDropdown(index) {
  const input = document.getElementById(`recipient-name-${index}`);
  const dropdown = document.getElementById(`dropdown-${index}`);

  if (input.value.length === 0) {
    populateDropdown(index, contactsData);
  }
  dropdown.style.display = "block";
}

// Hide dropdown with delay to allow for selection
function hideDropdown(index) {
  setTimeout(() => {
    const dropdown = document.getElementById(`dropdown-${index}`);
    dropdown.style.display = "none";
  }, 200);
}
